import PSAudio from './PSAudio';
import PSDropZone from './PSDropZone';

export const PS = {
    DropZone: PSDropZone,
    Audio: PSAudio,
};
